/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cargos_Sales_Range_InvalidInputs */

const en_cargos_sales_range_invalid = /** @type {(inputs: Cargos_Sales_Range_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The start date must be on or before the end date.`)
};

const es_cargos_sales_range_invalid = /** @type {(inputs: Cargos_Sales_Range_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La fecha de inicio debe ser igual o anterior a la fecha de fin.`)
};

/**
* | output |
* | --- |
* | "The start date must be on or before the end date." |
*
* @param {Cargos_Sales_Range_InvalidInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const cargos_sales_range_invalid = /** @type {((inputs?: Cargos_Sales_Range_InvalidInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cargos_Sales_Range_InvalidInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cargos_sales_range_invalid(inputs)
	return es_cargos_sales_range_invalid(inputs)
});